export const OPTIONS_FREQUENCY = [
	{ label: 'Daily', value: 'date' },
	{ label: 'Weekly (Mondays)', value: 'week' },
	{ label: 'Execute Now', value: 'now' }
]

export const OPTIONS_AMAZON_RELEASE_STATUS = [
	{ label: 'Action needed in Amazon Catalog', value: 'Action needed in Amazon Catalog' },
	{ label: 'Stock needed at Amazon', value: 'Stock needed at Amazon' },
]

export const OPTIONS_INCLUDE_NEW_PRODUCTS = [
	{ label: 'Include all products', value: 'No' },
	{ label: 'Include only New products', value: 'Yes' }
]

